import { render, staticRenderFns } from "./TextingPreferences.vue?vue&type=template&id=79f5faf3&scoped=true"
import script from "./TextingPreferences.vue?vue&type=script&lang=js"
export * from "./TextingPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f5faf3",
  null
  
)

export default component.exports